<ax-value-view-label [label]="label">
  <span>{{ name }}</span>
</ax-value-view-label>
